'use client';
import { Box, SxProps } from '@mui/material';
import RichText, { RichTextContent } from '../../../RichText';

type Props = {
  description?: RichTextContent;
  sx?: SxProps;
};

const Descriptions = ({ description, sx }: Props) => {
  return (
    <Box sx={sx}>
      <RichText>{description}</RichText>
    </Box>
  );
};

export default Descriptions;
